
import Vue from "vue";
import moment from "moment";
import {
  clampLimitLength,
  isAllAutoStart,
  hasManualStart,
  isAllChecked,
  uniqueOptionNames,
} from "./categoryOptionConfirm";
import type {
  CategoryOptionRow,
  MatchedOrderRow,
} from "./categoryOptionConfirm";

/**
 * ODR-1703 追随リファクタ: 飲み放題「コース開始処理」確認ポップアップの本体（共通）。
 *
 * ホーム（NotificationCategoryOption.vue）とカート（Cart.vue）で二重実装されていた
 * ポップアップ本体（巻き取り確認チェックリスト＋残り時間設定＋開始ボタン）を1つに統一する。
 * モーダル枠・データ源・開始APIの後処理は各画面（親）に残し、本コンポーネントは表示専用。
 *
 * - props: categoryOptions / matchedOrders（配列は参照渡し。チェックや残り時間の編集は親へ反映される）
 * - emit : start（親が start_category_option API と後処理を行う）
 */
export default Vue.component("CategoryOptionConfirm", {
  components: {
    QTranslate: () => import("../elements/QTranslate.vue"),
  },
  props: {
    categoryOptions: {
      type: Array as () => CategoryOptionRow[],
      required: true,
    },
    matchedOrders: {
      type: Array as () => MatchedOrderRow[],
      required: true,
    },
    // タイトルは画面ごとに異なる（ホーム=コース開始処理 / カート=注文完了）ので
    // 翻訳キーとフォールバックを受け取り、言語切替に追従するよう q-translate で描画する。
    titleKey: {
      type: String,
      required: true,
    },
    titleFallback: {
      type: String,
      default: "",
    },
    tableLabel: {
      type: String,
      default: "",
    },
  },
  computed: {
    names(): string {
      return uniqueOptionNames(this.categoryOptions);
    },
    allAuto(): boolean {
      return isAllAutoStart(this.categoryOptions);
    },
    hasManual(): boolean {
      return hasManualStart(this.categoryOptions);
    },
    allChecked(): boolean {
      return isAllChecked(this.matchedOrders);
    },
  },
  methods: {
    // 残り時間(分)を delta だけ増減（0〜600クランプ）
    adjustLimit(option: any, delta: number) {
      this.$set(option, "max_limit_length", clampLimitLength(Number(option.max_limit_length), delta));
    },
    // 全チェック切替
    onToggleAll(event: any) {
      const checked = event.target.checked;
      this.matchedOrders.forEach((menu: any) => {
        menu.is_checked = checked;
      });
    },
    // 注文時刻の HH:mm 表示
    formatTime(time: any): string {
      return time ? moment(time).format("HH:mm") : "";
    },
    // 終了予定時刻(目安) = 現在時刻 + 残り時間(分)。残り時間の編集に連動して再計算。
    estimatedEndTime(option: any): string {
      const mins = Number(option.max_limit_length);
      if (!Number.isFinite(mins)) {
        return "";
      }

      return moment().add(mins, "minutes").format("HH:mm");
    },
  },
  filters: {
    priceFilter(price: number): string {
      return new Intl.NumberFormat("ja-JP").format(price);
    },
  },
});
